module.exports = __webpack_public_path__ + "media/assets/avia/sidebar/austria-a675f1c7975688551b71bdafd2478dd3.png";